
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.7 3.7a.9.9 0 00-.9.9v10.8a.9.9 0 00.9.9h9.9V4.6a.9.9 0 00-.9-.9h-9zm0-1.8A2.7 2.7 0 001 4.6v10.8a2.7 2.7 0 002.7 2.7h12.6a2.7 2.7 0 002.7-2.7V7.3a2.7 2.7 0 00-2.7-2.7h-.9a2.7 2.7 0 00-2.7-2.7h-9zm11.7 4.5v9a.9.9 0 101.8 0V7.3a.9.9 0 00-.9-.9h-.9zm-10.8 0a.9.9 0 01.9-.9h5.4a.9.9 0 01.9.9V10a.9.9 0 01-.9.9H5.5a.9.9 0 01-.9-.9V6.4zm1.8.9v1.8H10V7.3H6.4zm-1.8 6.3a.9.9 0 01.9-.9h5.4a.9.9 0 110 1.8H5.5a.9.9 0 01-.9-.9z"}})])
          )
        }
      }
    